module.exports = __webpack_public_path__ + "img/28.3da92016.jpg";